// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1u5qO","paramInput":"JobSimulator_paramInput__3azkO","input":"JobSimulator_input__enmBA"};